import { Component, EventEmitter, OnInit, Output } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";

@Component({
  selector: "app-form-proveedor",
  templateUrl: "./form.component.html",
})
export class ProveedorForm implements OnInit {
  public form: FormGroup;
  public mode: "stanby" | "create" | "update" = "stanby";
  public defaults?: any = undefined;

  @Output() onsave = new EventEmitter<{ mode: string; value: any }>();
  constructor(private fb: FormBuilder) {}

  public ngOnInit() {
    this.buildForm();
  }
  public setStanby() {
    this.mode = "stanby";
    this.defaults = undefined;
    this.form.reset();
  }
  public setCreate() {
    this.mode = "create";
    this.defaults = undefined;
    this.form.reset();
  }

  public setUpdate(row: any) {
    this.mode = "update";
    this.defaults = row;
    this.form.controls["IdProveedor"].setValue(this.defaults?.IdProveedor);
    this.form.controls["Nombre"].patchValue(this.defaults?.Nombre);
    this.form.controls["Direccion"].patchValue(this.defaults?.Direccion);
  }

  public save() {
    if (this.mode === "create") this.create();
    else if (this.mode === "update") this.update();
  }

  public create() {
    this.onsave.emit({ mode: this.mode, value: this.form.value });
  }

  public update() {
    this.onsave.emit({ mode: this.mode, value: this.form.value });
  }

  public isCreateMode() {
    return this.mode === "create";
  }

  public isUpdateMode() {
    return this.mode === "update";
  }

  // TODO add validators
  private buildForm() {
    this.form = this.fb.group({
      IdProveedor: [""],
      Nombre: [""],
      Direccion: [""],
    });
  }
}
